var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsXFrameFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_sns_x_frame_filled_svg__clip0_37861_449453)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.156 22.07h2.033L11.833 8.975H9.8l9.356 13.095z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2a4 4 0 00-4 4v19.97a4 4 0 004 4h19.97a4 4 0 004-4V6a4 4 0 00-4-4H6zm16.511 6l-5.584 6.351L23 23h-4.467l-4.09-5.824L9.324 23H8l5.856-6.66L8 8h4.467l3.872 5.515L21.188 8h1.323z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_sns_x_frame_filled_svg__clip0_37861_449453"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgIconSnsXFrameFilled;